// src/utils/analyticsUtils.ts

export function runAfterConsent(callback: () => void) {
  if (typeof window === "undefined") return;

  const consent = localStorage.getItem("analytics_consent");
  if (consent === "granted") {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(callback);
    } else {
      setTimeout(callback, 100);
    }
  }
}
